
import React from 'react';
import PropTypes from 'prop-types';
import compose from 'recompose/compose';
import withWidth from '@material-ui/core/withWidth';
import { withStyles } from '@material-ui/core/styles';
import GridList from '@material-ui/core/GridList';
import GridListTile from '@material-ui/core/GridListTile';
import GridListTileBar from '@material-ui/core/GridListTileBar';
import Icon from '@material-ui/core/Icon';
import ReactPlayer from 'react-player';
// import Lazyload from 'react-lazyload';
import styled from 'styled-components';
import { Link } from "routes";
import Button from '@material-ui/core/Button';
import {
  isMobile,
  isBrowser
} from "react-device-detect";
import fontUniOrConvertZawgyi from '/utils/fontUniOrConvertZawgyi';
import SponsorFeatureBadge from '/components/sponsorFeatureBadge';
import ForwardButton from './ForwardButton';
import CardMedia from '@material-ui/core/CardMedia';
import NewsItemParts from '/components/newsItemParts';
import Lightbox from "react-image-lightbox";

const styles = (theme) => ({
    root: {
        maxWidth: 730,
        position: 'relative'
    },
    layout: {
      margin: '-3px auto -3px',
    },
    img:{
      width: '100%',
      cursor: 'pointer'
    },
    gridList: {
      width: '100%',
    },
    media: {
        height: 'auto',
    }
});

class ArticleDetailGraphic extends React.Component{
  constructor(props) {
    super(props);
 
    this.state = {
      isOpen: false,
    };
  }
    render(){
        const { classes, item, isServer } = this.props;
        const { isOpen } = this.state;
        const backgroundImg = "url('https://duwun-data.sgp1.cdn.digitaloceanspaces.com/react-assets/image/default-image-1000x500.png') no-repeat center center";
        const show_fullscreen = item.show_fullscreen && item.show_fullscreen;
        const responsiveHeightContain = isMobile ? 400 : 545;
        const adjustHeight = show_fullscreen ? 'auto' : responsiveHeightContain;
        const color = item.category.color && item.category.color;
        const graphicImg = item.graphic.thumb && item.graphic.thumb;
        return (
          <div className={classes.root}>
            <div className={classes.layout} >
              <GridList spacing={1} cols={1} rows={1} className={classes.gridList} style={{}}  >
                <GridListTile key={this.props.id} style={{padding: 0, height: adjustHeight, backgroundColor: '#535353'}}>
                  <div>
                    <SponsorFeatureBadge featured={item.featured} sponsored={item.is_sponsor} url={`/article/${item.slug}`} positionStyle={{zIndex: 1, left: 45, top: 16}} />
                    { graphicImg ?
                        <div className={classes.teaser}>
                          <CardMedia
                              component="img"
                              alt={item.title}
                              style={{
                                  height: adjustHeight,
                                  objectFit:'contain',
                                  cursor: 'pointer'
                              }}
                              image={graphicImg}
                              onClick={() => this.setState({ isOpen: true })}
                          />
                        </div>
                        : 
                        <Link route={`/article/${item.slug}`}>
                        <a className="anchor-link no-cover">
                            <img className={classes.img} style={{
                              position: 'absolute',
                              height: responsiveHeightCover,
                              objectFit: 'cover',
                              background: backgroundImg
                             }} src={backgroundImg} alt="Duwun Logo" />
                        </a>
                        </Link>
                    }
                    {isOpen && (
                      <Lightbox
                        mainSrc={graphicImg}
                        onCloseRequest={() => this.setState({ isOpen: false })}
                      />
                    )}
                    <ForwardButton isServer={isServer} url={this.props.url} item={item} />
                  </div>
                </GridListTile>
              </GridList>
              
            <div style={{marginTop: 10, marginLeft: 16, height: 'initial'}}>
            <NewsItemParts item={item} isGraphicAndCover typoComponent="h1" />
            </div>
            </div>
          </div>
        );
        
    }
}


ArticleDetailGraphic.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default compose(withStyles(styles), withWidth())(ArticleDetailGraphic);
